import {deleteJson, getJson, postJson} from '@/util/ajaxUtils';
import {API_ROOT} from '@/env';

export function getExtraNewsUrl(appId) {
    return `${API_ROOT}/extra/news?appId=${appId}`;
}

export function saveNews(news) {
    return postJson('/extra/news', {data: news});
}

export function deleteNews(newsId) {
    return deleteJson(`/extra/news/${newsId}`);
}

export function getNewsById(newsId) {
    return getJson(`/extra/news/${newsId}`);
}

export function getEntrypoint(entrypointId) {
    return getJson(`/extra/news/entrypoints/${entrypointId}`);
}

export function getEntrypointUrlRoot() {
    return getJson('/open/extra/news/urlroot');
}

export function getNewsItem(newsItemId) {
    return getJson(`/open/extra/news/items/${newsItemId}`);
}

export function getNewsStat(newsItemId) {
    return getJson(`/open/extra/news/stat/${newsItemId}`);
}

export function sendMessage(data) {
    return postJson(`/extra/news/send`, {data});
}
